import { styled } from '@sds-system/system';
import { getAllStyledProps } from '@sds-system/utils';
import type { StyledTypographyRootOptions } from './Typography.types';

export const StyledTypographyRoot = styled('span')<StyledTypographyRootOptions>(
  ({ textAlign, ellipsisLine }) => {
    return {
      ...(textAlign && { textAlign }),
      ...(ellipsisLine && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
        wordBreak: 'break-all',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: ellipsisLine,
        overflowWrap: 'break-all',
      }),
    };
  },
  getAllStyledProps,
);
